import {
  AHREFS_ANALYTICS_TOKEN,
  CLOUDFLARE_ANALYTICS_TOKEN,
  GOOGLE_ANALYTICS_TOKEN,
  IS_DEV,
  UMAMI_ANALYTICS_TOKEN,
  UMAMI_ANALYTICS_URL,
} from '@/client/confs/app';
import { useEffect, useRef } from 'react';

export const useAnalytics = () => {
  const ref = useRef(true);
  useEffect(() => {
    const elements: HTMLElement[] = [];
    if (!IS_DEV && ref.current) {
      ref.current = false;
      // cloudflare analytics
      if (CLOUDFLARE_ANALYTICS_TOKEN) {
        const scriptEl = document.createElement('script');
        scriptEl.type = 'text/javascript';
        scriptEl.src = 'https://static.cloudflareinsights.com/beacon.min.js';
        scriptEl.setAttribute('data-cf-beacon', `{ "token": "${CLOUDFLARE_ANALYTICS_TOKEN}" }`);
        document.body.appendChild(scriptEl);
        elements.push(scriptEl);
      }
      // google analytics
      if (GOOGLE_ANALYTICS_TOKEN) {
        const scriptEl = document.createElement('script');
        scriptEl.type = 'text/javascript';
        scriptEl.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_TOKEN}`;
        document.body.appendChild(scriptEl);
        elements.push(scriptEl);
        const scriptEl2 = document.createElement('script');
        scriptEl2.type = 'text/javascript';
        scriptEl2.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GOOGLE_ANALYTICS_TOKEN}');
        `;
        document.body.appendChild(scriptEl2);
        elements.push(scriptEl2);
        // google tag manager
        const scriptEl3 = document.createElement('script');
        scriptEl3.type = 'text/javascript';
        scriptEl3.innerHTML = `
            (function (w, d, s, l, i) {
              w[l] = w[l] || [];
              w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
              var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != 'dataLayer' ? '&l=' + l : '';
              j.async = true;
              j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
              f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', ${GOOGLE_ANALYTICS_TOKEN});
        `;
        document.body.appendChild(scriptEl3);
        elements.push(scriptEl3);
        // noscript tag
        const noscriptEl = document.createElement('noscript');
        noscriptEl.innerHTML = `
          <iframe src="https://www.googletagmanager.com/ns.html?id=${GOOGLE_ANALYTICS_TOKEN}" height="0" width="0" style="display: none; visibility: hidden" />
        `;
        document.body.appendChild(noscriptEl);
        elements.push(noscriptEl);
      }
      // ahrefs analytics
      if (AHREFS_ANALYTICS_TOKEN) {
        const scriptEl1 = document.createElement('script');
        scriptEl1.type = 'text/javascript';
        scriptEl1.src = 'https://analytics.ahrefs.com/analytics.js';
        scriptEl1.setAttribute('data-key', AHREFS_ANALYTICS_TOKEN);
        document.body.appendChild(scriptEl1);
        elements.push(scriptEl1);
      }
      // umami analytics
      if (UMAMI_ANALYTICS_URL && UMAMI_ANALYTICS_TOKEN) {
        const scriptEl = document.createElement('script');
        scriptEl.type = 'text/javascript';
        scriptEl.src = UMAMI_ANALYTICS_URL;
        scriptEl.setAttribute('data-website-id', UMAMI_ANALYTICS_TOKEN);
        document.body.appendChild(scriptEl);
        elements.push(scriptEl);
      }
    }
    return () => {
      if (!IS_DEV && elements.length > 0) {
        for (let i = 0; i < elements.length; i++) {
          const script = elements[i];
          document.body.removeChild(script);
        }
      }
    };
  }, []);
};

export default useAnalytics;
